import axios from "axios";
const getPriceBySku = (skuCode, serviceStore) => {
  let hasMinimumOrder = false;
  let url;
  const config = {
    headers: { Pragma: "no-cache" }
  };
  let selectedQuantity = 1;
  const selectedSku = serviceStore?.getters["product/getProductSku"];
  selectedQuantity = serviceStore?.getters["addToCartCount/getValidCartCount"];
  let selectedState="";
  selectedState = serviceStore?.getters["user/getSelectedStateCode"];
  const moq = selectedSku?.MinimumOrderQuantity;
  const uom = selectedSku?.MinimumOrderUOM;
  hasMinimumOrder = !!uom || !!moq;
  const priceEndpoint = _isFromRackShelfFinder()
    ? "ProductPriceSAP"
    : "ProductPrice";

  if (hasMinimumOrder) {
    const quantity = !moq ? "" : `&quantity=${moq}`;
    const unitOfMeasure = !uom ? "" : `&uom=${uom}`;

    url = `/ignitionapi/ProductService/${priceEndpoint}?productIds=${skuCode}${quantity}${unitOfMeasure}`;
  } else {
    url = `/ignitionapi/ProductService/${priceEndpoint}?productIds=${skuCode}&quantity=${selectedQuantity}&includeLeadTime=true&stateAbbreviation=${selectedState}`;
  }

  return axios.get(url, config);
};

// check if its a rack shelf item
function _isFromRackShelfFinder() {
  // URLSearchParams is not ie11 compatible
  const rackShelfModelParam = "model";
  const params = new URLSearchParams(window.location.search);
  return params.has(rackShelfModelParam);
}

export default {
  getPriceBySku
};
